import React from 'react';
import classNames from 'classnames';
import Card, { CardBody, CardHeader, CardLabel, CardTitle } from './bootstrap/Card';

const MoneyElement = ({ title, value, classLigth }) => {
    return (
        <Card
            className={classNames(
                'transition-base rounded-2 text-dark text-center',
                classLigth,
            )}
            shadow='sm'
            stretch
        >
            <CardHeader size="sm" className='bg-transparent border-0'>
                <CardLabel>
                    <CardTitle tag='h4' className='h5'>
                        {title}
                    </CardTitle>
                </CardLabel>
            </CardHeader>
            <CardBody className='pt-0'>
                <div className='fw-bold fs-3 mb-0'>
                    {value}
                </div>
            </CardBody>
        </Card>
    );
};

export default MoneyElement;